import { DaliServiceBase, WsDali } from "./wsdl/WsDali/v1.07/WsDali";

export {
    WsDali
};

export class DaliService extends DaliServiceBase {
}
